import React from 'react';
import Category from '../../components/CategoriesPage/Cagegory'
const CategoryPage = () => {
    return (
        <div>
            <Category/>
        </div>
    );
}

export default CategoryPage;
